/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import meetingSettings from './meeting-settings.mixin';

// Components
import Locations from 'ui/components/meetings/sub-pages/Locations.vue';
import Permissions from 'ui/components/meetings/sub-pages/Permissions.vue';
import Schedule from 'ui/components/meetings/sub-pages/Schedule.vue';
import Timings from 'ui/components/meetings/sub-pages/Timings.vue';
import Communication from 'ui/components/meetings/sub-pages/Communication.vue';

const __vue_script__ = {
    name: 'MeetingsSettings',

    components: { Locations, Permissions, Schedule, Timings, Communication },

    mixins: [meetingSettings],

    data() {
        return {
            currentComponent: 'Locations',
            subpages: ['Locations', 'Schedule', 'Permissions', 'Timings', 'Communication'],
            registry: null,
            settings: null
        };
    },

    async created() {
        await this.loadSettings();
    },
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "meetings-settings subpage" }, [
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "nav-list-wrapper" }, [
        _c("div", { staticClass: "repeated-item-list-container" }, [
          _c(
            "ul",
            { staticClass: "nav nav-list" },
            _vm._l(_vm.subpages, function (subpage) {
              return _c(
                "li",
                {
                  key: subpage,
                  class: { active: _vm.currentComponent === subpage },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "has-action",
                      on: {
                        click: function ($event) {
                          _vm.currentComponent = subpage
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "meetings.settings." +
                              _vm.$utils.strings.toSnakeCase(subpage) +
                              ".title"
                          )
                        )
                      ),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
      _vm.registry
        ? _c(
            "div",
            { staticClass: "view-wrapper" },
            [
              _c(
                _vm.currentComponent,
                _vm._b(
                  {
                    tag: "component",
                    attrs: { settings: _vm.settings, registry: _vm.registry },
                    on: {
                      save: _vm.saveSettings,
                      updated: function ($event) {
                        return _vm.loadSettings(true)
                      },
                    },
                  },
                  "component",
                  _vm.params,
                  false
                )
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/pages/meetings/MeetingsSettings.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__